import React from 'react';
import TribalIcon from './icons/TribalIcon'
import { Link } from 'react-router-dom';

const LogoHeader = () => {
    return (            
        <Link to="/" className="inline-flex items-center text-[30px] font-light tracking-widest">
            or
            <TribalIcon />
            ca
        </Link>
    );
}

export default LogoHeader;
